import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const Ferramentas = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Ferramentas";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.ferramentas})` }}>
        <div className="servico-hero-overlay">
          <h1>Ferramentas</h1>
          {/*<p>Para quem procura por as mais variadas ferramentas</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Ferramentas e Ferragens */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.ferramentasManuais} alt="" /></div>
            <h3>Montagem</h3>
            <p>Kits de chaves de fenda e parafusos.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.trenas} alt="" /></div>
            <h3>Medição</h3>
            <p>Trenas.</p>
          </div>

          <div></div>

          {/* 
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.macaricos} alt="" /></div>
            <h3>Maçaricos</h3>
            <p>Maçaricos.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.filtrosLinhas} alt="" /></div>
            <h3>Filtros de Linha</h3>
            <p>Filtros de Linha.</p>
          </div> */}

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('ferramentas')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('ferramentas')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default Ferramentas;